import React from "react";
import "./edit-profile.scss";
import AddIcon from "../../assets/add_icon.png";
import deletRedIcon from "../../assets/delet_red_icon.svg";
import UploadTemplateForm from "./UploadTemplateForm";

const ClinicDetailsForm = (props) => {
  const {
    onHandleChange,
    onHandleBlur,
    removeClick,
    addClick,
    errors,
    touched,
    push,
    remove,
    doctor_hospital_details,
    setFieldError,
    setUploadLogo,
    uploadLogo,
    setFieldValue,
    profile_details,
    setUploadLogoError,
  } = props;
  return doctor_hospital_details?.map((details, index) => {
    return (
      <>
        {/* <div className="row col-12 pt-2 form_container">
          <div className="form_row">Enter Clinic/Hospital Details</div>
          {index === 1 && (
            <div style={{marginRight: "28px"}}>
              <img
                src={deletRedIcon}
                style={{ width: "16px", cursor: "pointer" }}
                alt="delete"
                onClick={() => {
                  removeClick(index, remove);
                }}
              />
            </div>
          )}
        </div> */}
        <div className="mt-3" key={index}>
          <div className="d-flex justify-content-between">
            <div className="personal_details_row">
              Clinic/Hospital Details {index + 1}
            </div>
            {index === 1 && (
              <div>
                <img
                  src={deletRedIcon}
                  style={{ width: "16px", cursor: "pointer" }}
                  alt="delete"
                  onClick={() => {
                    removeClick(index, remove);
                  }}
                />
              </div>
            )}
          </div>
          <div className="personal_details_row border-bottom">
            <div className="form_row pb-3 pt-3">
              <span className="form_label">
                Clinic/Hospital Name {index + 1}
              </span>
              <span className="form_value form_input_width">
                <textarea
                  name={`doctor_hospital_details.${index}.hospital_name`}
                  className="form-control form-text-area text_area_background"
                  // rows="2"
                  value={details?.hospital_name ? details?.hospital_name : ""}
                  // value="No.16/2, Opp 5Th Cross, Kaggadaspura Main
                  // Road,Bengaluru,Karnataka 560093 "
                  placeholder="Clinic/Hospital Name"
                  // disabled
                  onChange={onHandleChange}
                  onBlur={onHandleBlur}
                  // maxLength="1000"
                ></textarea>
                {errors &&
                  errors?.doctor_hospital_details &&
                  errors?.doctor_hospital_details[index] &&
                  touched &&
                  touched?.doctor_hospital_details &&
                  touched?.doctor_hospital_details[index] && (
                    <div className="error">
                      {errors.doctor_hospital_details[index].hospital_name}
                    </div>
                  )}
              </span>
              <div className="form_checkbox mobile_checkbox">
                <label class="container custom-checkbox mb-0">
                  <input
                    type="checkbox"
                    name={`doctor_hospital_details.${index}.is_hospital_name_enabled`}
                    checked={details.is_hospital_name_enabled}
                    onChange={onHandleChange}
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          {index === 0 && (
            <div className="personal_details_row border-bottom">
              <UploadTemplateForm
                title="Clinic/Hospital Logo"
                fileValidationLabel="Size limit : 5MB"
                error={
                  errors?.doctor_hospital_details &&
                  errors?.doctor_hospital_details[index] &&
                  touched &&
                  touched?.doctor_hospital_details &&
                  touched?.doctor_hospital_details[index]
                    ? errors?.doctor_hospital_details[index]?.hospital_logo
                    : null
                }
                setUploadLogo={setUploadLogo}
                uploadLogo={uploadLogo}
                setFieldValue={setFieldValue}
                setUploadLogoError={setUploadLogoError}
                // values={profile_details}
                use_case="upload-document-rev1"
              />
              <div className="form_checkbox mobile_checkbox">
                <label class="container custom-checkbox mb-0">
                  <input
                    type="checkbox"
                    name={`doctor_hospital_details.${index}.is_hospital_logo_enabled`}
                    checked={details?.is_hospital_logo_enabled}
                    onChange={onHandleChange}
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          )}
          <div className="personal_details_row border-bottom">
            <div className="form_row pb-3 pt-3">
              <span className="form_label">
                Clinic/Hospital Address {index + 1}
              </span>

              <span className="form_value form_input_width">
                <textarea
                  name={`doctor_hospital_details.${index}.hospital_address`}
                  className="form-control form-text-area text_area_background"
                  // rows="2"
                  //         value="No.16/2, Opp 5Th Cross, Kaggadaspura Main
                  // Road,Bengaluru,Karnataka 560093 "
                  placeholder="Address"
                  onChange={onHandleChange}
                  onBlur={onHandleBlur}
                  value={
                    details?.hospital_address ? details?.hospital_address : ""
                  }
                  // disabled
                  // maxLength="1000"
                ></textarea>
                {errors &&
                  errors?.doctor_hospital_details &&
                  errors?.doctor_hospital_details[index] &&
                  touched &&
                  touched?.doctor_hospital_details &&
                  touched?.doctor_hospital_details[index] && (
                    <div className="error">
                      {errors?.doctor_hospital_details[index]?.hospital_address}
                    </div>
                  )}
              </span>
              <div className="form_checkbox mobile_checkbox">
                <label class="container custom-checkbox mb-0">
                  <input
                    type="checkbox"
                    name={`doctor_hospital_details.${index}.is_hospital_address_enabled`}
                    checked={details?.is_hospital_address_enabled}
                    onChange={onHandleChange}
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div className="personal_details_row border-bottom">
            <div className="form_row pb-3 pt-3">
              <span className="form_label">
                Clinic/Hospital Contact No.{index + 1}
              </span>
              <span className="form_value form_input_width">
                <input
                  type="text"
                  name={`doctor_hospital_details.${index}.hospital_contact_number`}
                  placeholder="Contact No."
                  // value="+917856239871"
                  value={
                    details?.hospital_contact_number
                      ? details?.hospital_contact_number
                      : ""
                  }
                  className="form_input text_area_background"
                  onChange={onHandleChange}
                  onBlur={onHandleBlur}
                />
                {errors &&
                  errors?.doctor_hospital_details &&
                  errors?.doctor_hospital_details[index] &&
                  touched &&
                  touched?.doctor_hospital_details &&
                  touched?.doctor_hospital_details[index] && (
                    <div className="error">
                      {
                        errors?.doctor_hospital_details[index]
                          ?.hospital_contact_number
                      }
                    </div>
                  )}
              </span>
              <div className="form_checkbox mobile_checkbox">
                <label class="container custom-checkbox mb-0">
                  <input
                    type="checkbox"
                    name={`doctor_hospital_details.${index}.is_hospital_contact_no_enabled`}
                    checked={details?.is_hospital_contact_no_enabled}
                    onChange={onHandleChange}
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div className="personal_details_row border-bottom">
            <div className="form_row pb-3 pt-3">
              <span className="form_label">
                Clinic/Hospital Timings {index + 1}
              </span>
              <span className="form_value form_input_width">
                <textarea
                  name={`doctor_hospital_details.${index}.hospital_timings`}
                  className="form-control form-text-area text_area_background"
                  // rows="2"
                  // value="Monday to Saturday - 9:00 AM to 5:00 PM Sunday - Closed"
                  value={
                    details?.hospital_timings ? details?.hospital_timings : ""
                  }
                  placeholder="Clinic/Hospital Timings"
                  // disabled
                  onChange={onHandleChange}
                  onBlur={onHandleBlur}
                  // maxLength="1000"
                ></textarea>
                {errors &&
                  errors?.doctor_hospital_details &&
                  errors?.doctor_hospital_details[index] &&
                  touched &&
                  touched?.doctor_hospital_details &&
                  touched?.doctor_hospital_details[index] && (
                    <div className="error">
                      {errors?.doctor_hospital_details[index]?.hospital_timings}
                    </div>
                  )}
              </span>
              <div className="form_checkbox mobile_checkbox">
                <label class="container custom-checkbox mb-0">
                  <input
                    type="checkbox"
                    name={`doctor_hospital_details.${index}.is_hospital_timings_enabled`}
                    checked={details?.is_hospital_timings_enabled}
                    onChange={onHandleChange}
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          {doctor_hospital_details?.length < 2 && (
            <div className="personal_details_row">
              <div className="pb-3 pt-4">
                <button
                  style={{
                    backgroundColor: "#fff",
                    color: "#17BAE0",
                    fontSize: "14px",
                  }}
                  type="button"
                  onClick={() => {
                    addClick(push, setFieldValue);
                  }}
                >
                  <img src={AddIcon} alt="add" className="mr-1" /> Add
                  Clinic/Hospital
                </button>
              </div>
            </div>
          )}
        </div>
      </>
    );
  });
};
export default ClinicDetailsForm;
